<template>
  <div class="alert-viewer fixed bottom-0 z-20 mb-2 w-full">
    <PAlert
      v-if="currentAlert"
      :type="currentAlert.type"
      :title="currentAlert.title"
      :description="currentAlert.body"
      class="mx-1 md:mx-2"
      size="large"
      closable
      @close="onAlertClose"
    >
      <template v-if="currentAlert.action" #actions="{ buttonColor }">
        <GeneralButton :color="buttonColor" @click="onAlertAction">
          {{ currentAlert.action.label }}
        </GeneralButton>
      </template>
    </PAlert>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { useAlertStore } from "@/store/alert.store"
import PAlert from "@/components/elements/PAlert.vue"
import GeneralButton from "@/components/inputs/GeneralButton.vue"

const alertStore = useAlertStore()
const { currentAlert } = storeToRefs(alertStore)

function onAlertClose() {
  alertStore.displayNextAlert()
}

async function onAlertAction() {
  const action = currentAlert.value?.action
  if (!action) return

  await action.handler()
  onAlertClose()
}
</script>

<style scoped></style>
